/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface DecrementLoyaltyPointsRequestContent
 */
export interface DecrementLoyaltyPointsRequestContent {
    /**
     * 
     * @type {number}
     * @memberof DecrementLoyaltyPointsRequestContent
     */
    points?: number;
    /**
     * 
     * @type {string}
     * @memberof DecrementLoyaltyPointsRequestContent
     */
    reason?: string;
}


/**
 * Check if a given object implements the DecrementLoyaltyPointsRequestContent interface.
 */
export function instanceOfDecrementLoyaltyPointsRequestContent(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function DecrementLoyaltyPointsRequestContentFromJSON(json: any): DecrementLoyaltyPointsRequestContent {
    return DecrementLoyaltyPointsRequestContentFromJSONTyped(json, false);
}

export function DecrementLoyaltyPointsRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): DecrementLoyaltyPointsRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'points': !exists(json, 'points') ? undefined : json['points'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
    };
}

export function DecrementLoyaltyPointsRequestContentToJSON(value?: DecrementLoyaltyPointsRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'points': value.points,
        'reason': value.reason,
    };
}

